import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class RequestToUpdatePassword {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * RequestToUpdatePassword constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Send request for password reset.
     *
     * @param {String} email
     * @param {String} password
     * @param {String} confirmPassword
     * @param {String} token
     *
     * @returns {Promise}
     */
    handle(email, password, confirmPassword, token) {
        return this.apiService
            .patch(ApiEndpoints['auth.reset-password.update'], {
                email: email,
                password: password,
                password_confirmation: confirmPassword,
                token: token,
            });
    }
}
